export const checkFrontZero = (time: number) => time < 10 ? `0${time}` : time;

export const createPerodioTimeString = (time: number) => `${checkFrontZero(Math.floor(time / 60))}:${checkFrontZero(time % 60)}`;

export const definePeriod = (time: number) => {
    if (time <= 1200) return 1;
    if (time > 1200 && time <= 2400) return 1;
    if (time < 2400) return 3;
}